import { Box, FormControl, styled } from '@mui/material';

export const ContainerStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'width',
})(({ width }) => ({
  width,
}));

export const FormControlStyled = styled(FormControl)(({ theme }) => ({
  marginTop: theme.spacing(2),
  width: '100%',
}));
